import { Button, Tooltip, useToaster } from '@enterprise-ui/canvas-ui-react'
import EnterpriseIcon, { ImagesIcon } from '@enterprise-ui/icons'
import apiConfig from '../../../config/'
import { isItemhubDomain } from '../../../resources/searchUtills'

const RedirectToPipeline = ({ selectedTcins }) => {
  const toaster = useToaster()
  const redirectToPipelineDetails = async () => {
    try {
      const basePipelineUrl = isItemhubDomain
        ? `${window.location.origin}/pipeline/v2/`
        : `${apiConfig.pipeline.baseUrl}`
      const pipelineDetailsUrl = `${basePipelineUrl}${apiConfig.pipeline.detailsPath}${selectedTcins}`
      window.open(pipelineDetailsUrl, '_blank', 'noopener,noreferrer')
    } catch (error) {
      toaster({
        type: 'error',
        heading: 'Error Redirecting to Pipeline',
        message:
          error.message || 'An unknown error occurred while redirecting.',
      })
    }
  }

  return (
    <>
      <Tooltip content="Manage Images" location="top">
        <Button
          type="ghost"
          onClick={redirectToPipelineDetails}
          className="button-bg-hover-transparent"
          disabled={selectedTcins.length === 0}
        >
          <EnterpriseIcon
            icon={ImagesIcon}
            size="md"
            className="hc-clr-contrast-weak"
          />
        </Button>
      </Tooltip>
    </>
  )
}

export default RedirectToPipeline
